import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import settings from '../public/settings.json';
import store from './store'
import axios from 'axios'
import 'regenerator-runtime/runtime'

import VueMeta from 'vue-meta'

Vue.use(VueMeta)

Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)



const baseAPI = axios.create({
  baseURL: settings.apiURL
});

const UNAUTHORIZED = 401;


Vue.mixin({
  methods: {
    GetBaseUrl() {
      return settings.apiURL;
    },
    UserAuth() {
      return this.$API
        .get(this.$UserAuth, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 202) {
            return true;
          } else
            return false;
        });
    },
    // GoToLogin() {
    //   let path = this.$router.currentRoute.path;
    //   if (path.toLowerCase() != "/login") {

    //     this.$router.push({
    //       path: '/Login',
    //       query: {
    //         targetUrl: this.$router.currentRoute.fullPath,
    //       }
    //     })

    //   }
    // },
    GoToSignUp() {
      let path = this.$router.currentRoute.path;
      if (path.toLowerCase() != "/index") {
        this.$router.push("/Index");
      }
    },
    GoToHome() {
      this.$router.push("/Dashboard");
    },
    SignOut: function () {
      return this.$API
        .get(this.$SignOut, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 200) {
            this.$router.push("/Login");
          }
        });

    },
    GoToDashboard() {
      this.$router.push("/Dashboard");
    },
    GoToLogin() {
      let path = this.$router.currentRoute.path;
      if (path.toLowerCase() != "/Login") {

        this.$router.push({
          path: '/Login',
          query: {
            targetUrl: this.$router.currentRoute.fullPath,
          }
        })

      }
    },
    SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetail, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 200) {
            this.users = response.data;
            console.log(":testing" + this.users.userId);
          }
        });
    },
  }

})

baseAPI.interceptors.response.use(response => response, error => {
  const {
    status
  } = error.response;
  if (status == UNAUTHORIZED) {
    router.push("/Login");
  } else {
    console.log("test");
  }
  return Promise.reject(error);
  //
})

Vue.prototype.$API = baseAPI

Vue.prototype.$SubmitAladdinSays = 'ask-genie'
Vue.prototype.$Register = 'Insert/Register'
Vue.prototype.$LoginToken = 'Insert/LoginToken'
Vue.prototype.$UserAuth = 'Insert/IsAuthenticated'
Vue.prototype.$LoginUserDetail = 'Read/LoginUserDetail'
Vue.prototype.$GetListCountries = 'read/GetListCountries'
Vue.prototype.$ForgotPassword = 'insert/ForgotPassword'
Vue.prototype.$ValidateForgotPasswordCode = 'insert/ValidateForgotPasswordCode'
Vue.prototype.$ChangePassword = 'insert/ChangePassword'

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
